export enum Role {
  admin = "admin",
  customer = "customer",
  driver = "driver",
}
